import { useMemo } from "react";
import {
  BurnTemperatureSeriesNonSensitive,
  BurnTemperatureSeriesNonSensitiveImpl,
} from "../../BurnTemperatureSeriesNonSensitive";
import { YAxis } from "@mui/x-charts-premium";
import { interpolateRdYlBu } from "d3-scale-chromatic";

export const useYAxis = (
  maxY: number,
  multiSelect: boolean,
  burnTimeSeries: Array<BurnTemperatureSeriesNonSensitive> | undefined
): YAxis<"linear">[] => {
  const minY = useMemo(
    () =>
      burnTimeSeries !== undefined
        ? BurnTemperatureSeriesNonSensitiveImpl.getMinY(burnTimeSeries, 0)
        : 0,
    [burnTimeSeries]
  );

  return useMemo(() => {
    return [
      {
        max: maxY,
        min: minY,
        colorMap: multiSelect
          ? undefined
          : {
              type: "continuous",
              min: minY,
              max: maxY,
              color: (value) => interpolateRdYlBu(1 - (0.5 + 0.5 * value)),
            },
      } as YAxis<"linear">,
    ];
  }, [minY, maxY, multiSelect]);
};
